import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Iconic 45,000 sq. ft. grand entrance lobby",
    "2.9 Acres of landscaped open greens",
    "100+ elevators for seamless vertical connectivity",
  ];
  const highlights2 = [
    "Reflexology path, cabanas & kids’ swimming pool",
    "Outdoor gaming zones & tiered landscape gardens",
    "Curated privacy with exclusive gated living",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Welcome to Adani Bandra Reclamation - where Mumbai’s prestige meets
        Adani’s pioneering vision. Located in the glitzy Bandra West, this
        new-age residential marvel is set to redefine luxury by fusing advanced
        lifestyle tech with world-class design and architecture.
        <br />
        Spread across a sprawling 24-acre land parcel near the Bandra-Worli Sea
        Link, Adani Bandra promises a rare blend of privacy, peace, and premium
        community living. From a 45,000 sq. ft. grand lobby to 100+ elevators
        and curated cabanas, every detail is engineered to amplify comfort and
        sophistication.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
